import { Component } from '@angular/core';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { QPointButtonComponent } from '../../../../projects/qpoint-button/src/lib/button/button.component';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { QPointToolbarComponent, QPointContentContainerComponent } from '@qpoint/layout';
import { 
  QPointTableRowComponent, 
  QPointDateTimePickerComponent
} from '../../../../projects/qpoint-forms/src/public_api';

@Component({
    selector: 'qpoint-control-gallery-table-row',
    templateUrl: './table-row.component.html',
    styleUrls: ['./table-row.component.scss'],
    imports: [
        QPointToolbarComponent,
        QPointContentContainerComponent,
        QPointTableRowComponent,
        TextBoxModule,
        QPointButtonComponent,
        DropDownListModule,
        DatePickerModule,
        QPointDateTimePickerComponent
    ]
})
export class ControlGalleryTableRowComponent {
  constructor() { }

  iconMouseEvent($event: MouseEvent) {
    console.log('Icon mouse event', $event);
  }
}
